import Head from "../../elements/head/head";
import Footer from "../../elements/footer/footer";
import "./contacts.scss";
import Paper from "@mui/material/Paper";
import { API_MEDIA } from "../../env";
import { styled } from "@mui/material/styles";
import BannerApp from "../../elements/banner/Banner";
import LeftSideBarApp from "../../elements/left_side_bar/Left_side_bar";
import Grid from "@mui/material/Grid";
import { useEffect, useState, useRef } from "react";
import FixedBottomNavigation from "../../elements/navigation/navigation";
import { useSelector } from "react-redux";
import api from "../../api";
import Progress from "../../elements/progress/progress";
import RecipeReviewCard from "./card";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const SideBar = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(0),
  textAlign: "center",
  color: theme.color.secondary,
}));

const Contacts = (args) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const search = useSelector((state) => state.searchSelector.search);
  const countRef = useRef(0);
  //   const [totalTimeSpent, setTotalTimeSpent] = useState(null);

  const getContactsFunc = () => {
    setLoading(true);
    api.getContacts(search).then((response) => {
      console.log("Запрос контактов");
      setData(response.data.sportsmens);
    });
    setLoading(false);
  };

  useEffect(() => {
    getContactsFunc(search);
  }, [search]);

  return loading ? (
    <Progress load={loading} />
  ) : (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Head />
      </Grid>

      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10, xl: 10 }}>
          <BannerApp />
        </Grid>

        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
      </Grid>

      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ lg: 1, xl: 1 }}
        ></Grid>
        <Grid
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "none",
              lg: "block",
              xl: "block",
            },
          }}
          size={{ md: 2, lg: 2, xl: 2 }}
        >
          <SideBar>
            <LeftSideBarApp />
          </SideBar>
        </Grid>

        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}>
          <Paper>
            <Grid
              // size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 8 }}
              spacing={1}
              padding={1}
              container
              direction="rows"
              sx={{
                justifyContent: "left",
                // alignItems: "center",
              }}
            >
              {data &&
                data.map((item) =>
                  item.status === "prezident" ? (
                    <Grid
                      size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}
                      spacing={1}
                    >
                      <RecipeReviewCard
                        title={item.first_name + " " + item.last_name}
                        subheader="Президент Федерации"
                        tel={item.phone}
                        email={item.email}
                        description={item.aboutself}
                        image={item.image}
                        status="П"
                        forEmail="Президенту"
                      />
                    </Grid>
                  ) : item.status === "secret" ? (
                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                      <RecipeReviewCard
                        title={item.first_name + " " + item.last_name}
                        subheader="Секретарь Федерации"
                        tel={item.phone}
                        email={item.email}
                        description={item.aboutself}
                        image={item.image}
                        status="С"
                        forEmail="Секретарю"
                      />
                    </Grid>
                  ) : item.status === "andidoping" ? (
                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                      <RecipeReviewCard
                        title={item.first_name + " " + item.last_name}
                        subheader="Ответственный за Антидопинговую работу"
                        tel={item.phone}
                        email={item.email}
                        description={item.aboutself}
                        image={item.image}
                        status="О"
                        forEmail="Ответственному за Антидопинговую работу"
                      />
                    </Grid>
                  ) : item.status === "admin" ? (
                    <Grid size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 3 }}>
                      <RecipeReviewCard
                        title={item.first_name + " " + item.last_name}
                        subheader="Администратор сайта"
                        tel={item.phone}
                        email={item.email}
                        description={item.aboutself}
                        image={item.image}
                        status="А"
                        forEmail="Администратору сайта"
                      />
                    </Grid>
                  ) : (
                    <div></div>
                  ),
                )}
            </Grid>
          </Paper>
          {/* </div> */}
        </Grid>
      </Grid>
      <Grid
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "block",
            lg: "block",
            xl: "block",
          },
        }}
        size={{ lg: 1, xl: 1 }}
      ></Grid>

      <Grid size={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Contacts;
